export type WorkspaceType = 'staging' | 'production'

export const currentType = (): WorkspaceType => {
  const raw = import.meta.env.VITE_NODE_ENV
  // Anything not explicitly 'production' is treated as staging — safer
  // default than falling back to production (no prod data leak risk).
  return raw === 'production' || raw === 'prd' ? 'production' : 'staging'
}
